<template>
  <img
    :src="$store.getters['app/appLogo']"
    alt=""
    role="presentation"
  >
</template>

<style lang='scss' scoped>
  img {
    margin-right: rem-calc(12);
    width: rem-calc(32);
  }
</style>
